// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"DG-z"};